export const headingTag = (tag) => tag;
//# sourceMappingURL=headingTag.js.map